export default {
  'pages.home': 'Home page',
  'pages.about': 'Chi siamo',
  'pages.login_form': 'Modulo di Accesso',
  'pages.signup_success': 'Iscrizione riuscita',
  'pages.create_business_profile': 'Crea Profilo Aziendale',
  'pages.complete_profile': 'Completa Profilo',
  'pages.send_password_successfully': 'Password Inviato con Successo',
  'pages.forget_password': 'Hai dimenticato la password',
  'pages.ticket_mangment': 'Gestione dei Biglietti',
};
